export default {
    all: 'All'
}
